module.exports = "/_next/static/images/tk-b75bd46739b8e7b624504a82f9a7183f.svg";